import React from 'react'
import type { BodyRowConfig } from '@ztechapps/webui.data-tools'
import type { CompanyWithContacts, RouteDef, User } from '@ztechapps/common.contract'
import { UserTypeEnum } from '@ztechapps/common.contract'
import { Badge } from 'react-bootstrap'
import { Icon } from '@ztechapps/webui.util'
import { Link } from 'react-router-dom'
import { Tags } from '@ztechapps/webui.input'
import { useInject, WebuiIocKey } from '@ztechapps/webui.contract'

export type CompanyRenderDataBodyCellProps = {
  companyRoute: RouteDef
} & BodyRowConfig<CompanyWithContacts>

export const CompanyRenderDataBodyCellConfig = (props: CompanyRenderDataBodyCellProps) => {
  const { _id, name, contacts, status, address, companyRoute, tags } = props
  const linkTo = companyRoute.altPath({ _id })

  return {
    name: (
      <div className="d-flex align-items-center">
        <Icon name="building" className="me-2 text-primary" />
        <Link to={linkTo} className="fw-medium">
          {name}
        </Link>
      </div>
    ),

    city: <div>{address?.city || '-'}</div>,
    state: <div>{address?.state || '-'}</div>,
    status: <Badge bg={status === 'Active' ? 'success' : 'warning'}>{status}</Badge>,
    tags: <Tags dataArray={tags} />,
    contacts: <Tags dataArray={contacts} tagComponent={ContactTagComponent} maxVisible={5} />,
  }
}

const ContactTagComponent = (props: { value: User }) => {
  const contactRoute = useInject<RouteDef>(WebuiIocKey.routes.customerContactItem)
  const vendorRoute = useInject<RouteDef>(WebuiIocKey.routes.vendorContactItem)

  const linkToPath = props.value?.type === UserTypeEnum.customer ? contactRoute : vendorRoute

  return (
    <span>
      <Link to={linkToPath.altPath({ _id: props?.value?._id })}>{props?.value?.profile?.name}</Link>
    </span>
  )
}
